import { Observable } from "rxjs";

import { inject, injectable } from "tsyringe";
import { DacadooRepository } from "src/containers/dacadoo/repositories/dacadoo-repository";
import { autoBind } from "src/shared/decorators/autobind";

@injectable()
export class DacadooService {
    constructor(@inject("DacadooRepository") private repo: DacadooRepository) {}

    @autoBind
    isClient(): Observable<boolean> {
        return this.repo.isClient();
    }
}
